/**
 * useIsCoarsePointer
 *
 * Whether the primary pointer is a finger rather than a mouse.
 *
 * Used to decide whether keyboard hints ("Shift + Enter for a new line") are
 * worth showing. A viewport-width query answers a different question: a small
 * laptop window still has a keyboard, and a tablet in landscape still does not
 * have a Shift key.
 */

import { useEffect, useState } from "react";

const QUERY = "(pointer: coarse)";

export function useIsCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const query = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => setCoarse(event.matches);

    // Safari < 14 only has the deprecated addListener.
    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", onChange);
      return () => query.removeEventListener("change", onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return coarse;
}
